export default {
  // 通用
  cancel: "Cancel",
  save: "Save",
  sure: "Accept",
  state: "State",
  operation: "Operation",
  prompt: "Prompt",
  pleaseChoose: "Please choose",
  updateSuccess: "Update successfully",
  closeAccountSuccess: "Close account successfully",
  email: "Email",
  customerId: "Customer Id",
  sureDelete: "Are you sure you want to delete?",
  deleteSuccess: "Delete successfully",
  addSuccess: "Add successfully",
  saveSuccess: "Saved successfully",
  operateSuccess: "Successful operation",
  message: "Message",
  refresh: "Refresh",
  yes: "Yes",
  no: "No",
  import: "Import",
  importFilesuccess: "File imported successfully",
  exportFilesuccess: "File exported successfully",
  export: "Export",
  browse: "Browse",
  home: "Home",
  copySuccess: "Replication success",
  pleaseInput: "Please input",
  emailError: "E-mail format is incorrect",
  unSavedWarning: "You have unsaved data, please save and add",
  editUnSavedWarning: "Please save the current editing item first",
  loadMore: "Click to load more",
  noData: "No data",
  noMoreData: "No more data",
  delete: "Delete",
  copy: "Copy",
  edit: "Edit",
  pleaseChooseData: "Please select the data to be saved",
  total: "Total",
  exportPanel: "Export to panel",
  importPanel: "Import from panel",
  salesChannel: "Sales channel",
  lastLoginDate: "Last login date",
  globalLoadingText:
    "This operation can take several minutes to be processed...",
  globalLoading: "Loading",
  all: "All",
  empty: "EMPTY",
  notEmpty: "NOT EMPTY",
  version: "Version",
  logo: "logo",
  help: "Help",
  // 注册时的滑块组件
  swipeRight: "Swipe right to fill the puzzle",
  // 登录
  account: "Account",
  accountEmpty: "The account cannot be empty",
  confirmPassword: "Confirm password",
  customerIdCode: "Customer ID code",
  customerName: "Customer name",
  forgotPassword: "Forgot password?",
  sureResetPassword: "Are you sure to reset your password?",
  loginCheck: "The account or password cannot be empty",
  optionalInformation: "Optional information",
  password: "Password",
  register: "Register",
  rememberMe: "Remember me",
  systemName: "Configuration Tool",
  signIn: "Sign in",
  signOutPrompt: "Are you sure you want to quit the system?",
  nameEmpty: "The name cannot be empty",
  passwordEmpty: "The password cannot be empty",
  confirmPasswordEmpty: "The confirm password cannot be empty",
  phoneEmpty: "The phone cannot be empty",
  emailEmpty: "The email cannot be empty",
  registerSuccess:
    "Please check your email to continue with the registration process",
  tryAgain: "Please try again",
  unagree: "Please tick to agree to the terms and conditions",
  // resetPasswordSuccess: 'Password reset successfully, please go to email to confirm',
  resetPasswordSuccess:
    "If the user name matches our records, a password reset email will be sent",
  notModified: "You have not modified it",
  unsavedRemind: "You have uncommitted changes. Do you want to save them?",
  identityInvalid: "Identity information is invalid, please login again",
  // 配置文件
  createNewConfigFile: "Create a new configuration file",
  createNewProject: "Create a new project",
  openExistingProject: "Open existing project",
  loadConfigFile: "Load an existing configuration file",
  // 顶部head
  userInfo: "User info",
  changePassword: "Change password",
  myProjects: "My projects",
  accountManagement: "Account management",
  signOut: "Sign out",
  // 修改密码
  currentPassword: "Current password",
  newPassword: "New password",
  confirmNewPassword: "Confirm new password",
  checkCurrentPwd: "The current password cannot be empty",
  checkNewPwd: "The new password cannot be empty",
  checkConfirm: "The confirm new password cannot be empty",
  checkConfirmSame: "The confirm password is not the same as the new password",
  currentNewPasswordCheck:
    "The new password cannot be the same as the current password",
  changePwdSuccess: "Password changed successfully",
  // 个人信息
  name: "Name",
  language: "Language",
  emailAddress: "Email address",
  phone: "Phone",
  closeAccount: "Close account",
  closeAccountPermanently:
    "Permanently delete account information and services data.",
  closeAccountPermanentlyAll:
    "Closing your account will permanently delete all your information and you will no longer be able to use any of services.",
  // 项目信息
  projectDialogNew: "Project information",
  projectDialogEdit: "Edit project",
  projectName: "Name",
  projectSite: "Project name",
  projectNote: "Note",
  projectPanelsList: "Panel",
  projectPanelMode: "Panel Mode",
  projectPanelTypeSingle: "Standalone",
  projectPanelTypeNetwork: "Network",
  projectPaneNo: "ID",
  projectPaneNote: "DESCRIPTION",
  projectNewSuccess: "Create Success",
  editTableError: "Please Save The Edit Table",
  myProjectDialog: "My projects",
  projectTablesite: "PROJECTNAME",
  projectTablepanelsNumber: "NUMBERS OF PANELS",
  projectTablecreatedTime: "CREATION TIME",
  projectTablemodifyTime: "LAST EDIT TIME",
  projectTablenotes: "NOTES",
  projectTableDelete: "Deleted successfully",
  projectEditSuccess: "Update successfully",
  projectTableCopy: "Copy successfully",
  projectTableEdit: "Edit Project",
  projectTableDown: "Download successfully",
  projectTablePanelWarning: "No Panels",
  projectLeadTitle: "Import file",
  projectLeadRowName: "Select File",
  projectLeadRowButtom: "Upload",
  projectLeadRowButtomselectBefore: "Select",
  folderLeadSuccess: "Folder Import successfully",
  projectLeadSuccess: "Project Import successfully",
  projectAddRequired: "Required Items Are Incomplete",
  projectSelectPanels: "Select Panel",
  projectInfoPanelTheadPanelNo: "PANEL NO.",
  projectInfoPanelTheaddesc: "DESCRIPTION",
  projectInfoPanelsWarning: "No panel selected",
  panelDetail: "Panel detail",
  panelAddSuccess: "Add Panel successfully",
  panelUpdateSuccess: "Update Panel successfully",
  panelDeleteSuccess: "Delete Panel successfully",
  // 账号管理
  disable: "Disable",
  disabled: "Disabled",
  enable: "Enable",
  enabled: "Enabled",
  activate: "Activate",
  activated: "Activated",
  inactivated: "Inactivated",
  disabledSuccess: "Disabled successfully",
  activateSuccess: "Successfully activated",
  enabledSuccess: "Enabled successfully",
  // 子菜单
  readonlyInformation: "Panel logs",
  deviceTable: "Loop devices",
  zoneDelays: "Zone SND+FR Delays",
  daynightSchedule: "Day/night settings",
  advancedProgramming: "Advanced programming",
  systemSettings: "System settings",
  myDownload: "My download",
  // 设备
  loop: "Loop",
  channel: "channel",
  address: "Address",
  type: "Type",
  description: "Description",
  zone: "Zone",
  group: "Group",
  sensitivityDuringProfileL1: "Sensitivity during profile L1",
  sensitivityDuringProfileL2: "Sensitivity during profile L2",
  sensitivityDuringProfileL3: "Sensitivity during profile L3",
  deviceExportSuccess: "Export successful. Please download in 'My download'",
  // sensitivityTips: 'Sensitivity tips',
  // profile: 'Profile',
  // sensitivitySmoke: 'Sensitivity smoke',
  // 校验规则
  outOfRange: "The Numbers are out of range",
  tooLong: "Characters are too long",
  // Zone SDN+FR delays
  activeSNDByDET: "Activate SND by DET alarm",
  doesSNDDelayApplyToDETAlarms: "Apply SND delay to DET alarm",
  SNDDelay: "SND delay (s)",
  activeSNDByMCP: "Activate SND by MCP alarm",
  doesSNDDelayApplyToMCPAlarms: "Apply SND delay to MCP alarm",
  activeFRByDET: "Activate FR by DET alarm", //
  doesFRDelayApplyToDETAlarms: "Apply FR delay to DET alarm",
  FRDelay: "FR delay (s)",
  activeFRByMCP: "Activate FR by MCP alarm",
  doesFRDelayApplyToMCPAlarms: "Apply FR delay to MCP alarm",
  resoundSoundersIfNewZoneInAlarm: "Resound sounders if new zone in alarm",
  // schedule
  week: "Week",
  dayStart: "Day start(Set delays On at this time)",
  sensitivityProfileDuringDay: "Sensitivity profile during day",
  nightStart: "Night start (Set delays Off at this time)",
  sensitivityProfileDuringNight: "Sensitivity profile during night",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  notSet: "NOT SET",
  // 编码
  actionNumber: "Action number",
  scenario: "Scenario",
  activation: "Activation",
  line: "Line",
  alarmType: "Alarm type",
  quantityOfAlarms: "Quantity of alarms",
  groupToActivate: "Group to activate",
  combination: "Combination",
  delay: "Delay",
  hold: "PULSE? (MAX 63 s; 0->NO)",
  twoStages: "Two Stages",
  twoStagesVersionTip:
    "This feature requires controller software version 0.6.10 or higher",
  actionNumLimit: "Action number cannot exceed 400 lines!",
  scenarioLimit: "Cannot exceed 32 lines!",
  activationLimit: "Cannot exceed 16 lines!",
  // system setting
  maintenanceCompanyDetails: "Maintenance company details",
  company: "Company",
  telephone: "Telephone",
  projectName: "Project name",
  personOfContact: "Person of contact",
  setLanguage: "Set language",
  loopClass: "Loop class",
  setPassword: "Set password",
  setupPrinter: "Setup printer",
  systemConfiguration: "System configuration",
  notes: "Notes",
  classB: "Class B",
  classA: "Class A",
  off: "off",
  on: "on",
  operatorPassword: "Operator password",
  installerPassword: "Installer password",
  power: "Power",
  mode: "Mode",
  eventsPrinted: "Events printed",
  systemLoopCard: "# of loopcard in the system",
  loopsInTheSystem: "# of loops in the system",
  LEDPanels: "# LED panels",
  chargerCards: "# charger cards",
  systemBoards: "# of IO boards in the system",
  systemNetwork: "# of Network card in the system",
  twoStagesOAT: "Operator Access Time (s)",
  twoStagesIDT: "Investigation Time (s)",
  mark: "Region",
  user: "User",
  time: "Time",
  // information-info
  timeAndDateTheConfig: "Time and date the configuration was saved",
  serialNumber: "Serial number",
  firmwareVersions: "Firmware versions",
  dateOfLastConfig: "Date of last configuration change in the panel",
  eventLog: "Event log",
  operatorPasswordCheck: "Operator password is not 3 digits",
  installerPasswordCheck: "Installer password is not 10 digits",
  // zone-setting
  zoneSettings: "Zone settings",
  zoneGroupTable: "Zone/Group table",
  //silenceableGroup
  silenceableGroup: "Silenceable Group",
  //
  configureNetwork: "Configure networking information",
  networkingInformation: "networking information",
  localAddr: "Local Addr",
  networkMode: "Network Mode",
  networkClass: "Network Class",
  dataTransferDevice: "Data transfer device",
  rs485: "RS485",
  sendFilter: "Send filter",
  send: "send",
  doNotSend: "do not send",
  Alarm: "Alarm",
  Fault: "Fault",
  Disable: "Disable",
  Reset: "Reset",
  Silence: "Silence",
  Time: "Time",
  Delay: "Delay",
  sendNetMap: "Set Net Map",
  startAddr: "Start Addr",
  endAddr: "End Addr",
  acceptanceFiltering: "Acceptance filtering",
  reception: "reception",
  noReception: "no reception",
  addressCheck:
    "The starting address cannot be greater than the ending address",
  notDataFill: "Data not filled in",
  //setIoCard
  setIoCard: "Set the IO card",
  IOBoard: "IO board",
  Func: "Func",
  allowedMaxLoad: "Allowed max load",
  FaultCheck: "FaultCheck",
  none: "none",
  Output: "Output",
  Feedback: "Feedback",
  RTFAULT: "RT-FAULT",
  groupBySndCK: "Activate group by SND control Key",
  assign: "Assign",
  // my download
  filename: "Filename",
  status: "Status",
  startTime: "Start time",
  endTime: "End time",
  download: "Download",
  inExport: "In the export",
  success: "Success",
  failure: "Failure",
  templateFile: "Template file",
  importDeviceMsg: "Import an existing device table",
  importZoneDelays: "Import an existing zone delays set",
  importAdvance:
    "Import an existing advanced programming, include action, scenario and activation",
  // register success
  successAccoutRequest: "Successful account request!",
  accountAdministrator:
    "Your request has been forwarded to our (human) account administrator.",
  approvalApplication:
    "You account will be active after our approval of your application.",
  passwordResetSuccess: "Password reset success!",
  resetSuccessful: "Reset successful, password is 12345678",
  dayTitle: "Sensitivity Profiles: L1 = Day L2 = Night L3 = Special",
  creationTime: "Create time",
  search: "search",
  limits: "Grant Jade Bird Support Account Access",
  content:
    "Customer support now has access to your account details for 14 days. You can revoke permission at any time by tapping the toggle again, putting it into the 'inactive' state.",
  contentLast:
    "To improve your experience, we recommend making sure this option is enabled before you call technical support.",
  apply: "apply",
  Successful: "Successful application",
  msg: "Last application time:",
  userName: "user name",
  applicationTime: "Support Time",
  showAll: "show all projects",
  to: "to",
  startDate: "Start date",
  endDate: "End date",
  porjectMsg: "Please enter keyword",
  stateApply: "Support State",
  statusApply: "Enable"
};
